import { Stack } from 'src/components-v2/Layout';
import { Button } from 'src/components-v2/Inputs';
import { targetMap } from 'src/lib/constants';
import { Link } from 'src/components/Inputs';
import { EmbeddedEntryButton } from './EmbeddedEntryButton';
import {
  getButtonGroupStackAlignItems,
  getButtonGroupStackDirection,
} from './button-group-direction';

const ButtonGroup = ({ node }) => {
  const fields = node?.data?.target?.fields;
  const buttons = fields?.buttons || [];
  const stackDirection = getButtonGroupStackDirection(fields?.direction);
  const stackAlignItems = getButtonGroupStackAlignItems(fields?.alignment);
  const stackGap = fields?.gap ?? undefined;

  return (
    <Stack
      direction={stackDirection}
      className='button-group'
      {...(stackGap !== undefined ? { gap: stackGap } : {})}
      alignItems={stackAlignItems}
      sx={{ ...fields?.styles }}
    >
      {buttons.map((button, i) => {
        const buttonFields = button?.fields;

        switch (button?.sys?.contentType?.sys?.id) {
          case 'hyperlink':
            return (
              <Link
                key={`button-${i}`}
                href={buttonFields?.url}
                variant={
                  buttonFields?.appearance === 'text with arrow' ? 'cta' : ''
                }
                color={buttonFields?.color || 'black'}
                trackingId={buttonFields?.trackingId || ''}
                sys={button?.sys}
              >
                <a target={targetMap[buttonFields.target] || '_self'}>
                  {buttonFields?.text}
                </a>
              </Link>
            );
          case 'targetButton': {
            const variant =
              buttonFields?.appearance === 'filled'
                ? 'contained'
                : buttonFields?.appearance;
            return (
              <Button
                key={`button-${i}`}
                variant={variant}
                href={buttonFields?.url}
                target={targetMap[buttonFields.target]}
                trackingId={buttonFields?.trackingId || ''}
                sys={button?.sys}
              >
                {buttonFields?.text}
              </Button>
            );
          }
          case 'button2':
            return (
              <EmbeddedEntryButton
                key={`button-${i}`}
                fields={buttonFields}
                node={button}
              />
            );
          default:
            return null;
        }
      })}
    </Stack>
  );
};

ButtonGroup.displayName = 'ButtonGroup';

export default ButtonGroup;
